import React, { memo } from 'react';
import { DateTime } from 'luxon';
import styles from './DateContent.module.scss';
import { appEnvironment } from '@benzinga/utils';

export interface AuthorContentProps {
  created: string;
  isDraft?: boolean;
  readTime: string;
}

export const DateContent: React.FC<AuthorContentProps> = memo(({ created, isDraft, readTime }) => {
  const articleCreationTime = created
    ? DateTime.fromISO(created, { setZone: true })
        .setZone(appEnvironment().config().zone)
        .toFormat('LLLL d, yyyy h:mm a')
    : null;

  return (
    <div className={`${styles.container} article-date-wrap text-sm`}>
      {isDraft && <span className="draft-badge">Draft</span>}{' '}
      <span className="article-date text-white">{articleCreationTime}</span>
      {readTime && <span className="article-read-time ml-2 inline-block rounded"> {readTime} </span>}
    </div>
  );
});
